// extracted by mini-css-extract-plugin
export default {"dlGeneratedLayout":"src-js-components-GeneratedLayout---dlGeneratedLayout----mefi"};